export const SetCoinsStateActionType = 'SET_COINS_STATE';
export const setCoinsState = newState => ({
  type: SetCoinsStateActionType,
  coinState: newState
});
